import client from '../client';
import type { ApiResponse } from '../../types/api';

export type QuestionnaireQuestionType = 'single' | 'multi' | 'text' | 'rating';

export interface ActiveQuestionnaireQuestion {
  id: string;
  type: QuestionnaireQuestionType;
  text: string;
  icon: string | null;
  required?: boolean;
  options?: string[];
  min?: number;
  max?: number;
}

export interface ActiveQuestionnaire {
  _id: string;
  title: string;
  description: string;
  questions: ActiveQuestionnaireQuestion[];
}

export const questionnairesApi = {
  active: async (storeId: string): Promise<ActiveQuestionnaire[]> => {
    const res = await client.get<ApiResponse<{ questionnaires: ActiveQuestionnaire[] }>>(
      `/dashboard/${storeId}/questionnaires/active`,
    );
    return res.data.data?.questionnaires || [];
  },

  respond: async (
    storeId: string,
    questionnaireId: string,
    answers: Record<string, unknown>,
  ): Promise<void> => {
    await client.post(`/dashboard/${storeId}/questionnaires/${questionnaireId}/respond`, { answers });
  },

  dismiss: async (storeId: string, questionnaireId: string): Promise<void> => {
    await client.post(`/dashboard/${storeId}/questionnaires/${questionnaireId}/dismiss`, {});
  },
};
